<div class="title">
  <label>Save options</label>
</div>
<div class="work-space">
  <div class="fieldset">
    <div class="row">
      <label>Only the values specified below will be saved.</label>
    </div>
    <div class="col-12">
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="exportGeneral" id="general_import_opt" class="form-check-input" type="checkbox" value="attributes" />
        <label class="form-check-label" for="general_import_opt">General - Name and location</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="exportAtts" id="attributes_import_opt" class="form-check-input" type="checkbox" value="attributes" />
        <label class="form-check-label" for="attributes_import_opt">Attributes - Point and Segment</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="exportSupplemental" id="suppl_import_opt" class="form-check-input" type="checkbox" value="supplementals" />
        <label class="form-check-label" for="suppl_import_opt">Attributes - Supplemental Fields</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="exportPresets" id="presets_import_opt" class="form-check-input" type="checkbox" value="presets" />
        <label class="form-check-label" for="presets_import_opt">Presets</label>
      </div>

    </div>

   </div>

</div>


<div class="footer full-width full-height centered">
  <label >Save To</label>
  <button (click)="SubmitConfig()" type="button" class="btn btn-sm btn-primary"><span class="icon fas fa-upload"></span>Server</button>
  <button (click)="SaveFile()" type="button" class="btn btn-sm btn-primary" ><span
      class="icon fas fa-floppy-disk rot-180"></span>File</button>
  <button (click)="Hide()" type="button" class="btn btn-sm btn-secondary" >Cancel</button>"
</div>
